import { api, LightningElement } from "lwc";

import { createTrack, TrackEvent } from "common/track";
import { ContentSummaryConfig, ContentSummary } from "tds/contentSummary";
import { Position } from "./types";
import { CtaEvent } from "tds/card";

export default class extends LightningElement {
  @api config: ContentSummaryConfig = null!;
  @api summary: ContentSummary | null = null;
  @api dynamicCta?: boolean;

  // This property is only needed if `tds-content-collection-item` is not a direct
  // child of `tds-content-collection-card`
  @api position: Position | null = null;

  private track = createTrack<"tds-summary">(this);

  private onNavigate() {
    this.dispatchEvent(new CustomEvent("navigate", { detail: this.summary }));
  }

  private onDynamicCtaClick(e: CtaEvent) {
    this.dispatchEvent(
      new CustomEvent("dynamicctaclick", {
        detail: {
          ...e.detail,
          summary: this.summary,
        },
      })
    );
  }

  private handleContentSummaryTrack(e: TrackEvent<"tds-content-summary">) {
    this.track(e.detail.eventName, e.detail.payload);
  }
}
